import { Root } from '@makemydeal/dr-activities-credit-decision';
import { CREDIT_DECISION_ROUTE_ROOT } from '../constants';

const CreditDecision = () => {
    return <Root baseRoute={CREDIT_DECISION_ROUTE_ROOT} />;
};

export default CreditDecision;
